<div class="text-center p-3">
    <h1>{{ 'Turn emails into customer support tickets' | translate }}</h1>
    <img class="superdude" src="../../assets/images/superdude.png" />

    <div class="d-flex flex-column align-items-center justify-content-center">
        <button class="btn login-button orange" (click)="openIframe()" [disabled]="isLoading">
            {{ 'Log in with Socialboards' | translate }}
        </button>
        <button class="btn login-button azure-login mb-3" (click)="openIframe(true)" [disabled]="isLoading">
            @if (!isLoading) {
                <span>{{ 'Log in with Azure AD' | translate }}</span>
            } @else {
                <sb-loader [color]="'white'" [isSmall]="true"></sb-loader>
            }
        </button>
    </div>
</div>
@if (isDialogWindowOpened) {
    <div class="disabled-area"><sb-loader></sb-loader></div>
}
